<template>
  <v-container fluid grid-list-xs>
    <v-layout row wrap>
      <v-flex xs2 class="primary--text">Name:</v-flex>
      <v-flex xs4>{{ agency.name }}</v-flex>

      <v-flex xs2 class="primary--text">ID:</v-flex>
      <v-flex xs4>{{ agency.tracking_id }}</v-flex>

      <v-flex xs2 class="primary--text">Email:</v-flex>
      <v-flex xs4>{{ agency.email }}</v-flex>

      <v-flex xs2 class="primary--text">Cash Discount:</v-flex>
      <v-flex xs4>{{ agency.is_cashdiscount }}</v-flex>

      <v-flex xs2 class="primary--text">Cash Discount Schedule:</v-flex>
      <v-flex xs4>{{ agency.cashdiscount_schedule }}</v-flex>
    </v-layout>

    <v-layout row wrap align-center>
      <h3 class="pa-2 primary--text">Address</h3>
      <v-divider class="primary"></v-divider>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs2 class="primary--text">Address:</v-flex>
      <v-flex xs4>{{ agency.address }}</v-flex>

      <v-flex xs2 class="primary--text">City:</v-flex>
      <v-flex xs4>{{ agency.city }}</v-flex>

      <v-flex xs2 class="primary--text">State:</v-flex>
      <v-flex xs4>{{ agency.state }}</v-flex>

      <v-flex xs2 class="primary--text">Postal Code:</v-flex>
      <v-flex xs4>{{ agency.postal_code }}</v-flex>

      <v-flex xs2 class="primary--text">Phone:</v-flex>
      <v-flex xs4>{{ phone(agency.phone) }}</v-flex>

      <v-flex xs2 class="primary--text">County:</v-flex>
      <v-flex xs4>{{ agency.county }}</v-flex>

      <v-flex xs2 class="primary--text">Hours:</v-flex>
      <v-flex xs4 class="text-wrap">{{ agency.hours }}</v-flex>
    </v-layout>

    <v-layout row wrap align-center>
      <h3 class="pa-2 primary--text">Checking</h3>
      <v-divider class="primary"></v-divider>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs2 class="primary--text">ABA:</v-flex>
      <v-flex xs4>{{ agency.aba }}</v-flex>

      <v-flex xs2 class="primary--text">DDA:</v-flex>
      <v-flex xs4>{{ agency.dda_decoded }}</v-flex>
    </v-layout>

    <v-layout row wrap align-center>
      <h3 class="pa-2 primary--text">Transaction Services</h3>
      <v-divider class="primary"></v-divider>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs2 class="primary--text">Client ID:</v-flex>
      <v-flex xs4>{{ agency.trxservices_client_id }}</v-flex>

      <v-flex xs2 class="primary--text">Source ID:</v-flex>
      <v-flex xs4>{{ agency.trxservices_source_id }}</v-flex>

      <v-flex xs2 class="primary--text">Algorithm:</v-flex>
      <v-flex xs4>Rijndael</v-flex>

      <v-flex xs2 class="primary--text">Algorithm Mode:</v-flex>
      <v-flex xs4>CBC</v-flex>

      <v-flex xs2 class="primary--text">Algorithm Key:</v-flex>
      <v-flex xs4 class="text-wrap">{{ agency.trxservices_key }}</v-flex>

      <v-flex xs2 class="primary--text">Algorithm IV:</v-flex>
      <v-flex xs4 class="text-wrap">{{ agency.trxservices_iv }}</v-flex>
    </v-layout>

    <v-layout row wrap align-center v-if="agency.notes">
      <h3 class="pa-2 primary--text">Notes</h3>
      <v-divider class="primary"></v-divider>
      <v-flex xs12>{{ agency.notes }}</v-flex>
    </v-layout>

    <v-divider class="mb-2 mt-2 primary"></v-divider>

    <v-expansion-panel
      expand
      multiple
      class="elevation-0 pt-2"
    >
      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          Terminals
        </div>
        <Terminals ref="terminals" :accountId="agency.account_id" v-if="agency.account_id"></Terminals>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          Users
        </div>
        <Users ref="users" :accountId="agency.account_id" v-if="agency.account_id"></Users>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>

<script>
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

import Terminals from '@/components/manage/Terminals'
import Users from '@/components/manage/Users'

export default {
  components: {Terminals, Users},
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      panel: [false, false, false, false],
      agency: {}
    }
  },

  mounted () {
    this.load()
  },

  methods: {
    async load () {
      try {
        Bus.$emit('openWaitModal')

        if (!this.$route.params.id) {
          throw new Error('Invalid agency')
        }

        let data = await this.api({url: `/okdmv_agencies/${this.$route.params.id}`})
        console.log('Data')
        console.log(data)

        this.agency = data.data.agency
      } catch (error) {
        Bus.$emit('openModal', {status: 'error', message: error})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    }
  }
}
</script>

<style lang="less">
  .v-expansion-panel__container {
    margin: 5px;
  }
  .v-expansion-panel__header {
    background: var(--v-secondary-base) !important;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/okdmv/Agency.vue